import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  GetDropDownList,
  getEngagementMasterDataById,
  InsertUpdateEngagementMasterData,
  getStreamOptions,
  getStageOptions,
  getFunctionOwnerOptions,
  InsertUpdateEngagementStagesHistory,
  getBillingMonths,
  getCurreny,
} from "../../../Helpers/API/APIEndPoints";
import InputForm from "../../../Components/InputForm/InputForm";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import moment from "moment";
import {
  billingOptions,
  enagagementTypeOptions,
  engagementStatusOptions,
  poStatusOptions,
  streamOptions,
} from "../../../Common/CommonJson";
import notify from "../../../Helpers/ToastNotification";
import { getContext } from "../../../Helpers/Context/Context";
import { LoaderContext } from "../../../Helpers/Context/Context";
import Heading from "../../../Components/Heading/Heading";

const EngagementMasterEdit = () => {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [engagement, setEngagement] = useState("");
  const [povalue, setPovalue] = useState("");
  const [pomonths, setPomonths] = useState("");
  const [poResourcesPerMonth, setPoResourcesPerMonth] = useState("");
  const [budgetResourcesPerMonth, setBudgetResourcesPerMonth] = useState("");
  const [poMandaysPerMonth, setPoMandaysPerMonth] = useState("");
  const [budgetMandaysPerMonth, setBudgetMandaysPerMonth] = useState("");
  const [poMandays, setPoMandays] = useState("");
  const [budgetMandays, setBudgetMandays] = useState("");
  const [balanceMandays, setBalanceMandays] = useState("");
  const [spentMandays, setSpentMandays] = useState("");
  const [invoiceValue, setInvoiceValue] = useState("");
  const [balanceValue, setBalanceValue] = useState("");
  const [actualCost, setActualCost] = useState("");
  const [submitId, setSubmitId] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [customer, setCustomer] = useState<any>({});
  const [enagagementType, setEnagagementType] = useState<any>({});
  const [ExistingenagagementEditType, setExistingEditType] = useState<any>({}); //sangam 22-04-24

  const [poStatus, setPoStatus] = useState<any>(poStatusOptions[2]);
  const [billing, setBilling] = useState<any>({});
  /*vaishnavi*/
  const [amount, setAmount] = useState("");
  //
  const [application, setApplication] = useState<any>([]);
  const [engagementStatus, setEngagementStatus] = useState<any>({});

  const [streamValue, setStream] = useState<any>({}); //sangam 2-mar-2024
  const [existingStreamValue, setExistingStreamValue] = useState<any>({});   //Deepak 4-apr-2025

  const [phase, setPhase] = useState<any>([]);
  const [poExpiryDate, setPoExpiryDate] = useState<Date | null>(null);
  const [poCompletionDate, setPoCompletionDate] = useState<Date | null>(null);
  const [plannedCompletionDate, setPlannedCompletionDate] =
    useState<Date | null>(null);
  const [actualCompletionDate, setActualCompletionDate] = useState<Date | null>(
    null
  );
  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [streamsOptions, setStreamOptions] = useState<any>([]); //sangam
  const [applicationsOptions, setApplicationsOptions] = useState<any>([]);
  const [phasesOptions, setPhasesOptions] = useState<any>([]);
  const [formErrors, setFormErrors] = useState({});
  const [editMode, setEditMode] = useState(false);
  const context = getContext();
  let formErrorObj = {};
  const { showLoader, hideLoader } = useContext(LoaderContext); //added by mahesh
  const [disabled, setDisabled] = useState(false);
  const [stagesOptions, setStageOptions] = useState<any>({}); //sangam 16-4-24
  const [stageValue, setStages] = useState<any>({ value: 1, label: "Enquiry" }); //sangam 16-4-24
  const [Existingeditstage, setExistingEditStage] = useState<any>({}); //sangam 22-4-24
  const [functionOwnersOptions, setFunctionOwnersOptions] = useState<any>({}); //sangam 16-4-24
  const [functionOwners, setFunctionOwners] = useState<any>({}); //sangam 16-4-24
  const [ExistingfunctionOwners, setExistingFunctionOwners] = useState<any>({}); //sangam 16-4-24

  const [billingMonthOption, setbillingmonthoption] = useState([]); //sangam 16-6-24
  const [billingmonthvalue, setbillingmonth] = useState<any>([]);
  const [billingMonthDisable, setbillingmonthDisable] = useState(false);

  //Prashant 03-07-2024
  const [fetchedData, setFetchedData] = useState<any>(null);
  const [POCurrencyOptions, setPOCurrencyOptions] = useState<any>([]);
  const [POCurrencySelectData, setPOCurrencySelectData] = useState({
    value: 1,
    label: "INR",
  }); // useState<any>({});
  const [InrConvertRate, setInrConvertRate] = useState<any>(null);
  const [InrAmount, setInrAmount] = useState<any>();

  const getCurrency = async () => {
    const obj = {};

    const { data } = await APICall(getCurreny, "POST", obj);

    if (data != undefined || data != null) {
      let currencyArray = [];
      await data.map((currency: any) => {
        let tempObj = {
          value: currency.id,
          label: currency.currency,
        };
        currencyArray.push(tempObj);
      });
      setPOCurrencyOptions(currencyArray);
    }
  };

  // useEffect(() => {
  //   if (fetchedData) {
  //     // setInrConvertRate(fetchedData.inrConvertRate);
  //     console.log(fetchedData.inrConvertRate,'f');
  //     let value = (fetchedData.currencyId == 1 || fetchedData.currencyId == null) ? "1" : fetchedData.inrConvertRate;
  //     setInrConvertRate(value);
  //     console.log(value);
  //     console.log(InrConvertRate,'con')
  //     setInrAmount(
  //       fetchedData.currencyId == 1 || fetchedData.currencyId == null
  //         ? (Number(povalue) * Number(InrConvertRate)).toFixed(2)
  //         : fetchedData.inrAmount
  //     );
  //   }
  // }, [fetchedData,povalue]);

  useEffect(() => {
    (async () => {
      if (enagagementType.label === "AMC" || enagagementType.label === "T&M") {
        await getCurrency();
      }
    })();
  }, [state, enagagementType]);

  //Prashant
  useEffect(() => {
    if (amount && InrConvertRate) {
      setInrAmount((Number(amount) * Number(InrConvertRate)).toFixed(2));
    } else {
      setInrAmount("");
    }
  }, [amount, InrConvertRate]);
  //prashant
  useEffect(() => {
    //setInrConvertRate("");
    if (POCurrencySelectData && POCurrencySelectData.value == 1) {
      setInrConvertRate("1");
    }
    // } else {
    //   setInrConvertRate("");
    // }
  }, [POCurrencySelectData]);

  const submitApiCall = async (submitObj: any) => {
    const { data } = await APICall(
      InsertUpdateEngagementMasterData,
      "POST",
      submitObj
    );
    if (data && data > 0) {
      navigate(-1);
      if (submitId) {
        let hitoryObj = {
          EngagementId: Number(submitId),
          StageId: stageValue.value,
          CreatedBy: context.EmployeeId,
          EffectiveDate: moment().format("YYYY-MM-DD"),
          Remark: "",
        };
        const { data } = await APICall(
          InsertUpdateEngagementStagesHistory,
          "POST",
          hitoryObj
        );

        setSubmitId(0);
        notify(0, "Engagement updated successfully");
      } else {
        let historyObj = {
          EngagementId: 0,
          StageId: stageValue.value,
          CreatedBy: context.EmployeeId,
          EffectiveDate: moment().format("YYYY-MM-DD"),
          Remark: "",
        };
        //sangam
        const { data } = await APICall(
          InsertUpdateEngagementStagesHistory,
          "POST",
          historyObj
        );

        setSubmitId(0);
        notify(0, "Engagement saved successfully");
      }
    } else {
      if (submitId) {
        notify(1, "Engagement updation failed");
      } else {
        setSubmitId(0);
        notify(1, "Engagement saved failed");
      }
    }
  };

  const resetFunc = () => {
    setSubmitId(0);
    setCustomer({});
    setPoExpiryDate(null);
    setEngagement("");
    setPovalue("");
    setPomonths("");
    setBilling({});
    /*vaishnavi*/
    setAmount("");
    //
    setPoResourcesPerMonth("");
    setBudgetResourcesPerMonth("");
    setPoMandaysPerMonth("");
    setBudgetMandaysPerMonth("");
    setInvoiceValue("");
    setBalanceValue("");
    setActualCost("");
    setSpentMandays("");
    setPoMandays("");
    setBudgetMandays("");
    setIsActive(false);
    setPoCompletionDate(null);
    setPlannedCompletionDate(null);
    setActualCompletionDate(null);
    setPoStatus(poStatusOptions[2]);
    setEngagementStatus({
      label: "Not Started",
      value: 1,
    });
    setEnagagementType({});
    setbillingmonth([]);
  };

  const customerApiCall = async () => {
    let postObject = {
      searchFor: "customer",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let customerArray = [];
      await data.map((customer: any) => {
        let tempObj = {
          abb: customer.abbreviation,
          value: customer.id,
          label: customer.name,
        };
        customerArray.push(tempObj);
      });
      setCustomerOptions(customerArray);
    }
  };

  //sangam
  const streamApiCall = async () => {
    const { data } = await APICall(getStreamOptions, "GET");

    if (data != undefined || data != null) {
      let streamArray = [];
      await data.map((stream: any) => {
        let tempObj = {
          value: stream.value,
          label: stream.label,
        };
        streamArray.push(tempObj);
      });
      setStreamOptions(streamArray);
    }
  };

  const applicationsApiCall = async () => {
    let postObject = {
      searchFor: "applications",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let applicationArray = [];
      await data.map((application: any) => {
        let tempObj = {
          value: application.id,
          label: application.application,
        };
        applicationArray.push(tempObj);
      });
      setApplicationsOptions(applicationArray);
    }
  };

  const phaseApiCall = async () => {
    let postObject = {
      searchFor: "phases",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let phaseArray = [];
      await data.map((phase: any) => {
        let tempObj = {
          value: phase.id,
          label: phase.phase,
        };
        phaseArray.push(tempObj);
      });
      setPhasesOptions(phaseArray);
    }
  };

  const getEngagementByIdApiCall = async () => {
    if (state !== null) {
      let post = {
        id: state,
      };
      const { data } = await APICall(getEngagementMasterDataById, "POST", post);

      if (data !== null || typeof data !== "string") {
        let SpentMandates = 0;
        setSubmitId(data.id);
        setCustomer({ value: data.customerId, label: data.customerName });
        setEngagement(data.engagement);

        /*sangam */

        if (data.stream != null && data.streamName != null) {
          setStream({ value: data.stream, label: data.streamName });
        }

        setPovalue(Number(data.povalue).toFixed(2).toString());
        /*vaishnavi*/
        setAmount(Number(data.billingAmount).toFixed(2).toString());
        //
        setPomonths(Number(data.pomonths).toFixed(2).toString());
        setPoResourcesPerMonth(
          Number(data.poresourcesPerMonth).toFixed(2).toString()
        );
        setBudgetResourcesPerMonth(
          Number(data.budgetResoucesPerMonth).toFixed(2).toString()
        );
        setPoMandaysPerMonth(
          Number(data.pomanDaysPerMonth).toFixed(2).toString()
        );
        setBudgetMandaysPerMonth(
          Number(data.budgetMandaysPerMonth).toFixed(2).toString()
        );
        setInvoiceValue(Number(data.invoiceValue).toFixed(2).toString());
        setPoMandays(Number(data.pomanDays).toFixed(2).toString());
        setBudgetMandays(Number(data.budgetMandays).toFixed(2).toString());
        setIsActive(data.isActive);
        if (data.poexpiry) {
          setPoExpiryDate(new Date(data.poexpiry));
        } else {
          setPoExpiryDate(null);
        }
        if (data.pocompletionDate) {
          setPoCompletionDate(new Date(data.pocompletionDate));
        } else {
          setPoCompletionDate(null);
        }
        if (data.plannedCompletionDate) {
          setPlannedCompletionDate(new Date(data.plannedCompletionDate));
        } else {
          setPlannedCompletionDate(null);
        }
        if (data.actualCompletionDate) {
          setActualCompletionDate(new Date(data.actualCompletionDate));
        } else {
          setActualCompletionDate(null);
        }
        if (data.hoursSpent && data.hoursSpent >= 0) {
          SpentMandates = Number(data.hoursSpent) / 8.5;
          setSpentMandays(Number(SpentMandates).toFixed(2).toString());
        }
        if (
          data.povalue &&
          data.povalue >= 0 &&
          data.invoiceValue &&
          data.invoiceValue >= 0
        ) {
          let BalanceValue = Number(data.povalue) - Number(data.invoiceValue);
          setBalanceValue(Number(BalanceValue).toFixed(2).toString());
        }
        if (
          data.budgetMandays &&
          data.budgetMandays >= 0 &&
          SpentMandates &&
          SpentMandates >= 0
        ) {
          let BalanceMandays =
            Number(data.budgetMandays) - Number(SpentMandates);
          setBalanceMandays(Number(BalanceMandays).toFixed(2).toString());
        }
        if (SpentMandates && SpentMandates >= 0) {
          let ActualCost = Number(SpentMandates) * 7000;
          setActualCost(Number(ActualCost).toFixed(2).toString());
        }
        billingOptions.map((option: any) => {
          if (option.value === data.billing) {
            setBilling(option);
          }
        });

        poStatusOptions.map((option: any) => {
          if (option.value === data.postatus) {
            setPoStatus(option);
          }
        });
        engagementStatusOptions.map((option: any) => {
          if (option.value === data.engagementStatus) {
            setEngagementStatus(option);
          }
        });
        enagagementTypeOptions.map((option: any) => {
          if (option.value === data.engagementType) {
            setEnagagementType(option);
            if (data.currentStage != null && data.currentStageName != null) {
              setExistingEditType(option);
            }
            if (
              option.value === 3 ||
              option.value === 1 ||
              option.value === 4 ||
              option.value === 2
            )
              getStagesOptions(option.value);

            getFunctionOwner();
          }
        });

        if (data.currentStage != null && data.currentStageName != null) {
          setStages({ value: data.currentStage, label: data.currentStageName });
          setExistingEditStage({
            value: data.currentStage,
            label: data.currentStageName,
          });
        }

        if (data.functionOwner != null && data.functionOwnerName != null) {
          setFunctionOwners({
            value: data.functionOwner,
            label: data.functionOwnerName,
          });
          setExistingFunctionOwners({
            value: data.functionOwner,
            label: data.functionOwnerName,
          });
        }

        if(data.streamName != null && data.stream != null)
        {
          setStream({
            value : data.stream,
            label : data.streamName,
          });
          setExistingStreamValue({
            value : data.stream,
            label : data.streamName,
          });
        }

        //sangam 27-jun-204

        if (data.engagementType == 1 || data.engagementType == 4) {
          //Prashant
          const Data = data;
          setFetchedData(Data);
          setPOCurrencySelectData(
            data.currencyId == null
              ? { value: 1, label: "INR" }
              : { value: data.currencyId, label: data.currency }
          );

          setInrConvertRate(
            data.currencyId == 1 || data.currencyId == null
              ? "1"
              : data.inrConvertRate
          );
          setInrAmount(
            // data.currencyId == 1 || data.currencyId == null
            //   ? (Number(povalue) * Number(InrConvertRate)).toFixed(2):
            data.inrAmount
          );

          if (data.billingMonth) {
            let bM = data.billingMonth
              .split(",")
              .map((item) => Number(item.trim()));

            billingMonthOption.map((option: any) => {
              if (bM.includes(option.value)) {
                setbillingmonth((pre) => [...pre, option]);
              }
            });
          }
        }

        //
      }
    }
  };

  useEffect(() => {
    if (state != null) getEngagementByIdApiCall();
  }, [billingMonthOption]);

  //sangam 16-4-24
  const getStagesOptions = async (Id) => {
    let reqObj = {
      Id: Id,
    };
    const { data } = await APICall(getStageOptions, "POST", reqObj);

    if (data != undefined || data != null) {
      let stagesArray = [];
      await data.map((stage: any) => {
        let tempObj = {
          value: stage.value,
          label: stage.label,
        };
        stagesArray.push(tempObj);
      });

      setStageOptions(stagesArray);
    }
  };

  //sangam 16-4-24
  const getFunctionOwner = async () => {
    const { data } = await APICall(getFunctionOwnerOptions, "GET");

    if (data != undefined || data != null) {
      let functionOwnersArray = [];
      await data.map((fO: any) => {
        let tempObj = {
          value: fO.value,
          label: fO.label,
        };
        functionOwnersArray.push(tempObj);
      });

      setFunctionOwnersOptions(functionOwnersArray);
    }
  };

  //sangam
  const getBillingMonth = async () => {
    const { data } = await APICall(getBillingMonths, "POST", {});

    if (data != undefined || data != null) {
      let tempArr = [];
      await data.map((bm) => {
        let tempobject = {
          value: bm.id,
          label: bm.label,
        };
        tempArr.push(tempobject);
      });

      await setbillingmonthoption(tempArr);
    }
  };

  const onLoadApiCall = async () => {
    await customerApiCall();
    await streamApiCall();
    await applicationsApiCall();
    await getBillingMonth();
    await phaseApiCall();

    if (state !== null) {
      let post = {
        id: state,
      };

      await getEngagementByIdApiCall();
      await setEditMode(true);
    } else {
      await setEngagementStatus({
        label: "Not Started",
        value: 1,
      });
      await setSpentMandays("0");
      await setBalanceMandays("0");
      await setInvoiceValue("0");
      await setBalanceValue("0");
      await setActualCost("0");
      await setEditMode(false);
      await getFunctionOwner();
    }
  };

  useEffect(() => {
    onLoadApiCall();
  }, []);

  const onSubmitValidation = async () => {
    await setFormErrors({});
    if (
      !engagement ||
      engagement === "" ||
      engagement.toString().trim() === ""
    ) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagement_isEmpty"]: "Egagement can not be empty",
      }));
      formErrorObj["engagement_isEmpty"] = "Engagement can not be empty";
    }

    if (
      (!povalue || povalue === "" || povalue.toString().trim() === "") &&
      !(enagagementType.label === "INTERNAL")
    ) {
      setFormErrors((preState) => ({
        ...preState,
        ["povalue_isEmpty"]: "PO value can not be empty",
      }));
      formErrorObj["povalue_isEmpty"] = "PO value can not be empty";
    } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(povalue)) {
      setFormErrors((preState) => ({
        ...preState,
        ["povalue_isEmpty"]: "PO value should have maximum 2 decimals only",
      }));
      formErrorObj["povalue_isEmpty"] =
        "PO value should have maximum 2 decimals only";
    }
    // if (!poExpiryDate) {
    //   setFormErrors((preState) => ({
    //     ...preState,
    //     ["poExpiryDate_isEmpty"]: "PO Expiry Date can not be empty",
    //   }));
    //   formErrorObj["poExpiryDate_isEmpty"] = "PO Expiry Date can not be empty";
    // }

    //added by mahesh on 22-04-2024
    if (!engagementStatus || Object.keys(engagementStatus).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["engagementStatus_isEmpty"]: "Engagement status can not be empty",
      }));
      formErrorObj["engagementStatus_isEmpty"] =
        "Engagement status can not be empty";
    }
    //end

    if (!customer || Object.keys(customer).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["customer_isEmpty"]: "Customer can not be empty",
      }));
      formErrorObj["customer_isEmpty"] = "Customer can not be empty";
    }
    if (!poStatus || Object.keys(poStatus).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["poStatus_isEmpty"]: "PO status type can not be empty",
      }));
      formErrorObj["poStatus_isEmpty"] = "PO status type can not be empty";
    }
    if (!enagagementType || Object.keys(enagagementType).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["enagagementType_isEmpty"]: "Engagement type can not be empty",
      }));
      formErrorObj["enagagementType_isEmpty"] =
        "Engagement type can not be empty";
    }
    //sangam 4-mar-2024
    if (!streamValue || Object.keys(streamValue).length === 0) {
      setFormErrors((preState) => ({
        ...preState,
        ["stream_isEmpty"]: "Stream can not be empty",
      }));
      formErrorObj["stream_isEmpty"] = "Stream can not be empty";
    }

    //sangam 16-april-2024
    if (
      enagagementType.label === "AMC" ||
      enagagementType.label === "T&M" ||
      enagagementType.label === "PROJECT" ||
      enagagementType.label === "PRODUCT"
    ) {
      if (!stageValue || Object.keys(stageValue).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["stage_isEmpty"]: "Stage can not be empty",
        }));
        formErrorObj["stage_isEmpty"] = "Stage can not be empty";
      }
    }
    //sangam 16-april-2024
    if (
      enagagementType.label === "AMC" ||
      enagagementType.label === "T&M" ||
      enagagementType.label === "PROJECT" ||
      enagagementType.label === "PRODUCT"
    ) {
      if (!functionOwners || Object.keys(functionOwners).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["functionOwner_isEmpty"]: "Function owner not be empty",
        }));
        formErrorObj["functionOwner_isEmpty"] =
          "Function owner can not be empty";
      }
    }

    if (enagagementType.label === "AMC" || enagagementType.label === "T&M") {
      if (
        (billing.value == 2 || billing.value == 3) &&
        (!billingmonthvalue || Object.keys(billingmonthvalue).length === 0)
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["billingmonth_isEmpty"]: "Billing months can not be empty",
        }));
        formErrorObj["billingmonth_isEmpty"] =
          "Billing months can not be empty";
      } else if (
        billing.value == 2 &&
        billingmonthvalue &&
        billingmonthvalue.length != 4
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["billingmonth_isEmpty"]:
            "For quarter, only 4 months can be selected",
        }));
        formErrorObj["billingmonth_isEmpty"] =
          "For quarter, only 4 months can be selected";
      } else if (
        billing.value == 3 &&
        billingmonthvalue &&
        billingmonthvalue.length != 1
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["billingmonth_isEmpty"]:
            "For annually, only 1 month can be selected",
        }));
        formErrorObj["billingmonth_isEmpty"] =
          "For annually, only 1 month can be selected";
      } else if (
        (billing.value == 2 || billing.value == 3) &&
        (billingmonthvalue == null ||
          billingmonthvalue == undefined ||
          billingmonthvalue.length == 0)
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["billingmonth_isEmpty"]: "Billing month can not be empty",
        }));

        formErrorObj["billingmonth_isEmpty"] = "Billing month can not be empty";
      }

      if (!pomonths || pomonths === "" || pomonths.toString().trim() === "") {
        setFormErrors((preState) => ({
          ...preState,
          ["pomonths_isEmpty"]: "PO months can not be empty",
        }));
        formErrorObj["pomonths_isEmpty"] = "PO months can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(pomonths)) {
        setFormErrors((preState) => ({
          ...preState,
          ["pomonths_isEmpty"]: "PO months should have maximum 2 decimals only",
        }));
        formErrorObj["pomonths_isEmpty"] =
          "PO months should have maximum 2 decimals only";
      }
      if (!billing || Object.keys(billing).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["billing_isEmpty"]: "billing can not be empty",
        }));
        formErrorObj["billing_isEmpty"] = "billing can not be empty";
      }

      if (billing.value == 1 && amount === "") {
        setFormErrors((preState) => ({
          ...preState,
          ["amount_isEmpty"]: "Amount can not be empty",
        }));
        formErrorObj["amount_isEmpty"] = "Amount can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(amount)) {
        setFormErrors((preState) => ({
          ...preState,
          ["amount_isEmpty"]: "Amount should have maximum 2 decimals only",
        }));
        formErrorObj["amount_isEmpty"] =
          "Amount should have maximum 2 decimals only";
      }
      if (
        (!poResourcesPerMonth ||
          poResourcesPerMonth === "" ||
          poResourcesPerMonth.toString().trim() === "") &&
        enagagementType.label === "T&M"
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poResourcesPerMonth_isEmpty"]:
            "PO resources per month can not be empty",
        }));
        formErrorObj["poResourcesPerMonth_isEmpty"] =
          "PO resources per month can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(poResourcesPerMonth)) {
        setFormErrors((preState) => ({
          ...preState,
          ["poResourcesPerMonth_isEmpty"]:
            "PO resources per month should have maximum 2 decimals only",
        }));
        formErrorObj["poResourcesPerMonth_isEmpty"] =
          "PO resources per month should have maximum 2 decimals only";
      }
      if (
        (!budgetResourcesPerMonth ||
          budgetResourcesPerMonth === "" ||
          budgetResourcesPerMonth.toString().trim() === "") &&
        enagagementType.label === "T&M"
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetResourcesPerMonth_isEmpty"]:
            "Budget resources per month can not be empty",
        }));
        formErrorObj["budgetResourcesPerMonth_isEmpty"] =
          "Budget resources per month can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(budgetResourcesPerMonth)) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetResourcesPerMonth_isEmpty"]:
            "Budget resources per month should have maximum 2 decimals only",
        }));
        formErrorObj["budgetResourcesPerMonth_isEmpty"] =
          "Budget resources per month should have maximum 2 decimals only";
      }
      if (
        (!poMandaysPerMonth ||
          poMandaysPerMonth === "" ||
          poMandaysPerMonth.toString().trim() === "") &&
        enagagementType.label === "AMC"
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poMandaysPerMonth_isEmpty"]:
            "PO mandays per month can not be empty",
        }));
        formErrorObj["poMandaysPerMonth_isEmpty"] =
          "PO mandays per month can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(poMandaysPerMonth)) {
        setFormErrors((preState) => ({
          ...preState,
          ["poMandaysPerMonth_isEmpty"]:
            "PO mandays per month should have maximum 2 decimals only",
        }));
        formErrorObj["poMandaysPerMonth_isEmpty"] =
          "PO mandays per month should have maximum 2 decimals only";
      }
      if (
        (!budgetMandaysPerMonth ||
          budgetMandaysPerMonth === "" ||
          budgetMandaysPerMonth.toString().trim() === "") &&
        enagagementType.label === "AMC"
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandaysPerMonth_isEmpty"]:
            "Budget mandays per month can not be empty",
        }));
        formErrorObj["budgetMandaysPerMonth_isEmpty"] =
          "Budget mandays per month can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(budgetMandaysPerMonth)) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandaysPerMonth_isEmpty"]:
            "Budget mandays per month should have maximum 2 decimals only",
        }));
        formErrorObj["budgetMandaysPerMonth_isEmpty"] =
          "Budget mandays per month should have maximum 2 decimals only";
      }
      // if (!application || Object.keys(application).length === 0) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["application_isEmpty"]: "Application can not be empty",
      //   }));
      //   formErrorObj["engagement_isEmpty"] = "Application can not be empty"
      // }
    } else if (
      enagagementType.label === "PROJECT" ||
      enagagementType.label === "PRODUCT" ||
      enagagementType.label === "INTERNAL"
    ) {
      // if (!invoiceValue || invoiceValue === "" || invoiceValue.toString().trim() === "") {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["invoiceValue_isEmpty"]: "Invoice value can not be empty",
      //   }));
      //   formErrorObj["invoiceValue_isEmpty"] = "Invoice value can not be empty"
      // } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(invoiceValue)) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["invoiceValue_isEmpty"]: "Invoice value should have maximum 2 decimals only",
      //   }));
      //   formErrorObj["invoiceValue_isEmpty"] = "Invoice value should have maximum 2 decimals only"
      // }

      // if (!balanceValue || balanceValue === "" || balanceValue.toString().trim() === "") {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["balanceValue_isEmpty"]: "Balance value can not be empty",
      //   }));
      //   formErrorObj["balanceValue_isEmpty"] = "Balance value can not be empty"
      // } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(balanceValue)) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["balanceValue_isEmpty"]: "Balance value should have maximum 2 decimals only",
      //   }));
      //   formErrorObj["balanceValue_isEmpty"] = "Balance value should have maximum 2 decimals only"
      // }

      if (
        enagagementType.label === "PROJECT" ||
        enagagementType.label === "PRODUCT"
      ) {
        if (
          !poMandays ||
          poMandays === "" ||
          poMandays.toString().trim() === ""
        ) {
          setFormErrors((preState) => ({
            ...preState,
            ["poMandays_isEmpty"]: "PO mandays can not be empty",
          }));
          formErrorObj["poMandays_isEmpty"] = "PO mandays can not be empty";
        } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(poMandays)) {
          setFormErrors((preState) => ({
            ...preState,
            ["poMandays_isEmpty"]:
              "PO mandays should have maximum 2 decimals only",
          }));
          formErrorObj["poMandays_isEmpty"] =
            "PO mandays should have maximum 2 decimals only";
        }
      }

      if (
        !budgetMandays ||
        budgetMandays === "" ||
        budgetMandays.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandays_isEmpty"]: "Budget mandays can not be empty",
        }));
        formErrorObj["budgetMandays_isEmpty"] =
          "Budget mandays can not be empty";
      } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(budgetMandays)) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandays_isEmpty"]:
            "Budget mandays should have maximum 2 decimals only",
        }));
        formErrorObj["budgetMandays_isEmpty"] =
          "Budget mandays should have maximum 2 decimals only";
      }
      // if (!spentMandays || spentMandays === "" || spentMandays.toString().trim() === "") {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["spentMandays_isEmpty"]: "Spent mandays can not be empty",
      //   }));
      //   formErrorObj["spentMandays_isEmpty"] = "Spent mandays can not be empty"
      // } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(spentMandays)) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["spentMandays_isEmpty"]: "Spent mandays should have maximum 2 decimals only",
      //   }));
      //   formErrorObj["spentMandays_isEmpty"] = "Spent mandays should have maximum 2 decimals only"
      // }

      // if (!balanceMandays || balanceMandays === "" || balanceMandays.toString().trim() === "") {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["balanceMandays_isEmpty"]: "Balance mandays can not be empty",
      //   }));
      //   formErrorObj["balanceMandays_isEmpty"] = "Balance mandays can not be empty"
      // } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(balanceMandays)) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["balanceMandays_isEmpty"]: "Balance mandays should have maximum 2 decimals only",
      //   }));
      //   formErrorObj["balanceMandays_isEmpty"] = "Balance mandays can not be empty"
      // }

      // if (!actualCost || actualCost === "" || actualCost.toString().trim() === "") {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["actualCost_isEmpty"]: "Actual cost can not be empty",
      //   }));
      //   formErrorObj["actualCost_isEmpty"] = "Actual cost can not be empty"
      // } else if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(actualCost)) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["actualCost_isEmpty"]: "Actual cost should have maximum 2 decimals only",
      //   }));
      //   formErrorObj["actualCost_isEmpty"] = "Actual cost can not be empty"
      // }

      // if (!phase || Object.keys(phase).length === 0) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["phase_isEmpty"]: "phase can not be empty",
      //   }));
      //   formErrorObj["phase_isEmpty"] = "phase can not be empty"
      // }
      if (!engagementStatus || Object.keys(engagementStatus).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagementStatus_isEmpty"]: "Engagement status can not be empty",
        }));
        formErrorObj["engagementStatus_isEmpty"] =
          "Engagement status can not be empty";
      }
      // if (!poCompletionDate) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["poCompletionDate_isEmpty"]: "PO Completion Date can not be empty",
      //   }));
      //   formErrorObj["poCompletionDate_isEmpty"] =
      //     "PO Completion Date can not be empty";
      // }
      // if (!plannedCompletionDate) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["plannedCompletionDate_isEmpty"]:
      //       "Planned completion date Date can not be empty",
      //   }));
      //   formErrorObj["plannedCompletionDate_isEmpty"] =
      //     "Planned completion date Date can not be empty";
      // }
      // if (!actualCompletionDate) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["actualCompletionDate_isEmpty"]: "Actual completion date can not be empty",
      //   }));
      //   formErrorObj["actualCompletionDate_isEmpty"] = "Actual completion date can not be empty"
      // }
    }

    //Prashant
    if (!InrConvertRate) {
      setFormErrors((preState) => ({
        ...preState,
        ["INRConvertRate_isEmpty"]: "INR Conversion Rate cannot be empty",
      }));
      formErrors["INRConvertRate_isEmpty"] =
        "INR Conversion Rate cannot be empty";
    }

    if (
      !POCurrencySelectData ||
      Object.keys(POCurrencySelectData).length === 0
    ) {
      setFormErrors((preState) => ({
        ...preState,
        ["poCurrency_isEmpty"]: "Currency cannot be empty",
      }));
      formErrors["poCurrency_isEmpty"] = "Currency cannot be empty";
    }
  };

  const submitFunc = async (action: any) => {
    debugger;
    let submitObj: any = {};
    if (action === "submit") {
      setDisabled(true);
      showLoader();
      submitObj = {
        Engagement: engagement,
        CustomerId: customer.value,
        EngagementType: Number(enagagementType.value),
        EngagementStatus: Number(engagementStatus.value),
        Stream: Number(streamValue.value),
        Povalue: povalue ? Number(povalue) : null,
        Postatus: Number(poStatus.value),
        //  Poexpiry: moment(poExpiryDate).format(moment.HTML5_FMT.DATE),
        IsActive: isActive,
        CreatedBy: context.EmployeeId,
      };
      // if (poExpiryDate === null) {
      //   submitObj = {
      //     ...submitObj,
      //     Poexpiry: null,
      //   };
      // } else {
      //   submitObj = {
      //     ...submitObj,
      //     Poexpiry: moment(poExpiryDate).format(moment.HTML5_FMT.DATE),
      //   };
      // }
      if (enagagementType.label === "AMC" || enagagementType.label === "T&M") {
        let monthId;

        if (billingmonthvalue && billingmonthvalue.length > 0) {
          monthId = billingmonthvalue.map((month) => month.value).join(",");
        } else {
          monthId = "";
        }

        submitObj = {
          ...submitObj,
          Pomonths: Number(pomonths),
          Billing: Number(billing.value),
          BillingAmount: Number(amount),
          Poexpiry: moment(poExpiryDate).format(moment.HTML5_FMT.DATE),
          PoresourcesPerMonth: Number(poResourcesPerMonth),
          BudgetResoucesPerMonth: Number(budgetResourcesPerMonth),
          PomanDaysPerMonth: Number(poMandaysPerMonth),
          BudgetMandaysPerMonth: Number(budgetMandaysPerMonth),
          CurrentStage: Number(stageValue.value),
          FunctionOwner: Number(functionOwners.value),
          INRConvertRate: billing.value == 4 ? null : InrConvertRate,
          INRAmount: billing.value == 4 ? null : InrAmount,
          CurrencyId: billing.value == 4 ? null : POCurrencySelectData.value,
          BillingMonth:
            Number(billing.value) == 2 || Number(billing.value) == 3
              ? billingmonthvalue && monthId
              : null,
          // "ApplicationsData": application
          // let applicationRequestObject = {
          //   id: applicationId,
          //   application: application,
          //   engagementId: engagement.value,
          //   isActive: isActive,
          // }
        };

        if (poExpiryDate === null) {
          submitObj = {
            ...submitObj,
            Poexpiry: null,
          };
        } else {
          submitObj = {
            ...submitObj,
            Poexpiry: moment(poExpiryDate).format(moment.HTML5_FMT.DATE),
          };
        }
      } else if (
        enagagementType.label === "PROJECT" ||
        enagagementType.label === "PRODUCT" ||
        enagagementType.label === "INTERNAL"
      ) {
        submitObj = {
          ...submitObj,
          InvoiceValue: Number(invoiceValue),
          BalanceValue: Number(balanceValue),
          SpentMandates: Number(spentMandays),
          BalanceMandays: Number(balanceMandays),
          ActualCost: Number(actualCost),
          PocompletionDate: moment(poCompletionDate).format(
            moment.HTML5_FMT.DATE
          ),
          PlannedCompletionDate: moment(plannedCompletionDate).format(
            moment.HTML5_FMT.DATE
          ),
          ActualCompletionDate: moment(actualCompletionDate).format(
            moment.HTML5_FMT.DATE
          ),
          POManDays: Number(poMandays),
          BudgetMandays: Number(budgetMandays),
          // "PhasesData": phase
          // let phaseRequestObject = {
          //   id: phaseId,
          //   phase: phase,
          //   description: description,
          //   engagementId: engagement && engagement.value,
          //   plannedDate: plannedDate,
          //   actualDate: actualDate,
          //   isActive: isActive,
          // };
        };

        if (actualCompletionDate === null) {
          submitObj = {
            ...submitObj,
            ActualCompletionDate: null,
          };
        } else {
          submitObj = {
            ...submitObj,
            ActualCompletionDate: moment(actualCompletionDate).format(
              moment.HTML5_FMT.DATE
            ),
          };
        }

        if (plannedCompletionDate === null) {
          submitObj = {
            ...submitObj,
            PlannedCompletionDate: null,
          };
        } else {
          submitObj = {
            ...submitObj,
            PlannedCompletionDate: moment(plannedCompletionDate).format(
              moment.HTML5_FMT.DATE
            ),
          };
        }

        if (poCompletionDate === null) {
          submitObj = {
            ...submitObj,
            PocompletionDate: null,
          };
        } else {
          submitObj = {
            ...submitObj,
            PocompletionDate: moment(poCompletionDate).format(
              moment.HTML5_FMT.DATE
            ),
          };
        }

        if (
          enagagementType.label === "PROJECT" ||
          enagagementType.label === "PRODUCT"
        ) {
          submitObj = {
            ...submitObj,
            CurrentStage: Number(stageValue.value),
            FunctionOwner: Number(functionOwners.value),
          };
        }
      }
      if (submitId !== 0) {
        submitObj.Id = submitId;
        submitObj.ModifiedBy = context.EmployeeId;
        await onSubmitValidation();
      }
      await onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every(
        (f) => f === "" || f === null || f === undefined
      );

      if (isEmpty === true) {
        setDisabled(false);
        await submitApiCall(submitObj);
      } else {
        setDisabled(false);
      }
      hideLoader();
    }
    if (action === "reset") {
      resetFunc();
    }
  };

  const handleTextEvent = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "poExpiryDate") {
      setPoExpiryDate(event);
      // if (event) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["poExpiryDate_isEmpty"]: undefined,
      //   }));
      // } else {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["poExpiryDate_isEmpty"]: "PO expiry date can not be empty",
      //   }));
      // }
    }
    if (apiFieldName === "engagement") {
      setEngagement(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagement_isEmpty"]: "Egagement can not be empty",
        }));
      }
    }
    if (apiFieldName === "povalue") {
      setPovalue(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["povalue_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["povalue_isEmpty"]: "PO value can not be empty",
        }));
      }
    }
    if (apiFieldName === "pomonths") {
      setPomonths(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["pomonths_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["pomonths_isEmpty"]: "PO months can not be empty",
        }));
      }
    }
    if (apiFieldName === "poResourcesPerMonth") {
      setPoResourcesPerMonth(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poResourcesPerMonth_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "T&M" &&
        (!event.target.value || event.target.value.toString().trim() === "")
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poResourcesPerMonth_isEmpty"]:
            "PO Resources Per Month can not be empty",
        }));
      }
    }
    if (apiFieldName === "budgetResourcesPerMonth") {
      setBudgetResourcesPerMonth(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetResourcesPerMonth_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "T&M" &&
        (!event.target.value || event.target.value.toString().trim() === "")
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetResourcesPerMonth_isEmpty"]:
            "Budget Resources Per Month can not be empty",
        }));
      }
    }
    if (apiFieldName === "poMandaysPerMonth") {
      setPoMandaysPerMonth(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poMandaysPerMonth_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "AMC" &&
        (!event.target.value || event.target.value.toString().trim() === "")
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetResourcesPerMonth_isEmpty"]:
            "PO Mandays Per Month can not be empty",
        }));
      }
    }
    if (apiFieldName === "budgetMandaysPerMonth") {
      setBudgetMandaysPerMonth(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandaysPerMonth_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "AMC" &&
        (!event.target.value || event.target.value.toString().trim() === "")
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandaysPerMonth_isEmpty"]:
            "Budget mandays per month value can not be empty",
        }));
      }
    }
    if (apiFieldName === "poMandays") {
      setPoMandays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poMandays_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "PROJECT" &&
        (!event.target.value || event.target.value.toString().trim() === "")
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["poMandays_isEmpty"]: "PO Mandays can not be empty",
        }));
      }
    }
    if (apiFieldName === "budgetMandays") {
      setBudgetMandays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandays_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "PROJECT" &&
        (!event.target.value || event.target.value.toString().trim() === "")
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["budgetMandays_isEmpty"]: "Budget mandays can not be empty",
        }));
      }
    }
    if (apiFieldName === "spentMandays") {
      setSpentMandays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["spentMandays_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["spentMandays_isEmpty"]: "Spent Mandays can not be empty",
        }));
      }
    }
    if (apiFieldName === "balanceMandays") {
      setBalanceMandays(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["balanceMandays_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["balanceMandays_isEmpty"]: "Balance Mandays can not be empty",
        }));
      }
    }
    if (apiFieldName === "poCompletionDate") {
      setPoCompletionDate(event);
      // if (event) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["poCompletionDate_isEmpty"]: undefined,
      //   }));
      // } else {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["poCompletionDate_isEmpty"]: "PO Completion Date can not be empty",
      //   }));
      // }
    }
    if (apiFieldName === "plannedCompletionDate") {
      setPlannedCompletionDate(event);
      // if (event) {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["plannedCompletionDate_isEmpty"]: undefined,
      //   }));
      // } else {
      //   setFormErrors((preState) => ({
      //     ...preState,
      //     ["plannedCompletionDate_isEmpty"]:
      //       "Planned Completion Date can not be empty",
      //   }));
      // }
    }
    if (apiFieldName === "actualCompletionDate") {
      setActualCompletionDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["actualCompletionDate_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["actualCompletionDate_isEmpty"]:
            "Actual Completion Date can not be empty",
        }));
      }
    }
    if (apiFieldName === "actualCost") {
      setActualCost(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["actualCost_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["actualCost_isEmpty"]: "Actual Cost value can not be empty",
        }));
      }
    }
    if (apiFieldName === "balanceValue") {
      setBalanceValue(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["balanceValue_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["balanceValue_isEmpty"]: "Balance value can not be empty",
        }));
      }
    }
    if (apiFieldName === "invoiceValue") {
      setInvoiceValue(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["invoiceValue_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["invoiceValue_isEmpty"]: "Invoice value can not be empty",
        }));
      }
    }
    /*vaishnavi*/
    if (apiFieldName === "amount") {
      setAmount(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["amount_isEmpty"]: undefined,
        }));
      } else if (
        // !event.target.value ||
        // event.target.value === "" ||
        //event.target.value.toString().trim() === "" ||
        billing.value == 1
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["amount_isEmpty"]: "Amount  can not be empty",
        }));
      }
    } //

    //Prashant
    if (apiFieldName === "INRConvertRate") {
      setInrConvertRate(event.target.value);
      if (
        event.target.value &&
        event.target.value !== "" &&
        event.target.value.toString().trim() !== ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["INRConvertRate_isEmpty"]: undefined,
        }));
      } else if (
        !event.target.value ||
        event.target.value === "" ||
        event.target.value.toString().trim() === ""
      ) {
        setFormErrors((preState) => ({
          ...preState,
          ["INRConvertRate_isEmpty"]: "INR Conversion Rate can not be empty",
        }));
      }
    }

    if (apiFieldName === "INRAmount") {
      setInrAmount(event.target.value);
    }
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "stream") {
      //sangam 2-mar-2024
      setStream(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["stream_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["stream_isEmpty"]: "Stream can not be empty",
        }));
      }
    }

    if (apiFieldName === "stages") {
      //sangam 2-mar-2024
      setStages(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["stage_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "PROJECT" ||
        enagagementType.label === "PRODUCT" ||
        enagagementType.label === "T&M" ||
        enagagementType.label === "AMC"
      ) {
        if (!event || Object.keys(event).length === 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["stage_isEmpty"]: "Stage can not be empty",
          }));
        }
      }
    }

    if (apiFieldName === "functionOwner") {
      //sangam 2-mar-2024
      setFunctionOwners(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["functionOwner_isEmpty"]: undefined,
        }));
      } else if (
        enagagementType.label === "PROJECT" ||
        enagagementType.label === "PRODUCT" ||
        enagagementType.label === "T&M" ||
        enagagementType.label === "AMC"
      ) {
        if (!event || Object.keys(event).length === 0) {
          setFormErrors((preState) => ({
            ...preState,
            ["functionOwner_isEmpty"]: "Function owner can not be empty",
          }));
        }
      }
    }

    if (apiFieldName === "customer") {
      setCustomer(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["customer_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["customer_isEmpty"]: "Customer type can not be empty",
        }));
      }
    }
    if (apiFieldName === "enagagementType") {
      setEnagagementType(event);

      if (event.label === "INTERNAL") {
        setPoStatus({ value: 4, label: "Not Applicable" });
      }

      if (event.label === "PROJECT" || event.label === "PRODUCT") {
        if( 
          ExistingenagagementEditType !== null ||
            Object.keys(ExistingenagagementEditType).length !== 0
        ) {
          setStages(Existingeditstage);
          setFunctionOwners(ExistingfunctionOwners);
          console.log("Value  ===>",existingStreamValue)
          setStream(existingStreamValue);
        } else {
          setStages({ value: 1, label: "Enquiry" });
          setFunctionOwners({});
        }

        setStageOptions({});
        setFormErrors({});
        getStagesOptions(event.value); //sangam 16-4-24
        getFunctionOwner();
        setPomonths("");
        setBilling({});
        setPoResourcesPerMonth("");
        setBudgetResourcesPerMonth("");
        setPoMandaysPerMonth("");
        setBudgetMandaysPerMonth("");
        // setStream({});
      } else if (event.label === "AMC" || event.label === "T&M") {
        if (
          ExistingenagagementEditType !== null ||
            Object.keys(ExistingenagagementEditType).length !== 0
        ) {
          setStages(Existingeditstage);
          setFunctionOwners(ExistingfunctionOwners);
          console.log("Value  ===>",existingStreamValue)
          setStream(existingStreamValue);
        } else {
          setStages({ value: 1, label: "Enquiry" });
          setFunctionOwners({});
        }
        setStageOptions({});
        setFormErrors({});
        getStagesOptions(event.value); //sangam 16-4-24
        getFunctionOwner();
        setInvoiceValue("");
        setBalanceValue("");
        setActualCost("");
        setAmount("");
        setSpentMandays("");
        setPoMandays("");
        setBudgetMandays("");
        setPoCompletionDate(null);
        setPlannedCompletionDate(null);
        setActualCompletionDate(null);
        setPoStatus(poStatusOptions[2]);
        setEngagementStatus({
          label: "Not Started",
          value: 1,
        });
        // setStream({});
      }
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["enagagementType_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["enagagementType_isEmpty"]: "Enagagement type can not be empty",
        }));
      }
    }
    if (apiFieldName === "poStatus") {
      setPoStatus(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poStatus_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poStatus_isEmpty"]: "PO status can not be empty",
        }));
      }
    }
    if (apiFieldName === "billing") {
      setBilling(event);

      // if(event.value == 1 || event.value ==  4){
      setbillingmonth([]);
      //  }
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["billing_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["billing_isEmpty"]: "Billing can not be empty",
        }));
      }
    }

    //
    //sangam 26-06-2024
    if (apiFieldName === "billingmonth") {
      setbillingmonthDisable(false);
      setbillingmonth(event);

      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["billingmonth_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["billingmonth_isEmpty"]: "Billing months can not be empty",
        }));
      }

      // if(billing.value == 2 && billingmonthvalue.length > 3){
      //   setFormErrors((preState)=>({
      //     ...preState,
      //     ["billingmonth_isEmpty"]:"For quarter, only three months can be selected"
      //     }))
      // }else if(billing.value == 3 && billingmonthvalue.length>1){
      //   setFormErrors((preState)=>({
      //     ...preState,
      //     ["billingmonth_isEmpty"]:"For annually, only one month can be selected"
      //     }))
      // }
    }

    if (apiFieldName === "application") {
      setApplication(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["application_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["application_isEmpty"]: "Application can not be empty",
        }));
      }
    }
    if (apiFieldName === "engagementStatus") {
      setEngagementStatus(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagementStatus_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["engagementStatus_isEmpty"]: "Engagement status can not be empty",
        }));
      }
    }
    if (apiFieldName === "phases") {
      setPhase(event);
      if (event && Object.keys(event).length > 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["phases_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["phases_isEmpty"]: "Phase can not be empty",
        }));
      }
    }

    //Prashant
    if (apiFieldName === "POCurrency") {
      setInrConvertRate("");
      setPOCurrencySelectData(event);

      if (event && Object.keys(event).length > 0) {
        setInrConvertRate(event.value == 1 ? 1 : "");
        setFormErrors((preState) => ({
          ...preState,
          ["poCurrency_isEmpty"]: undefined,
        }));
      } else if (!event || Object.keys(event).length === 0) {
        setFormErrors((preState) => ({
          ...preState,
          ["poCurrency_isEmpty"]: "Currency can not be empty",
        }));
      }
    }
  };

  useEffect(() => {
    if (billing.value == 2 && billingmonthvalue.length > 4) {
      setFormErrors((preState) => ({
        ...preState,
        ["billingmonth_isEmpty"]: "For quarter, only 4 months can be selected",
      }));
    } else if (billing.value == 3 && billingmonthvalue.length > 1) {
      setFormErrors((preState) => ({
        ...preState,
        ["billingmonth_isEmpty"]: "For annually, only 1 month can be selected",
      }));
    }
  }, [billingmonthvalue]);

  return (
    <>
      <Heading title={"Engagement Master"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Name <sup>*</sup>
              </label>
              <InputForm
                placeholder={"Engagement"}
                isDisabled={false}
                textArea={false}
                value={engagement}
                onChange={(e) => handleTextEvent(e, "engagement")}
              />
              <p style={{ color: "red" }}>{formErrors["engagement_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Customer <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={customerOptions}
                placeholder="Select"
                isDisabled={false}
                value={customer}
                onChange={(event) => selectOnChange(event, "customer")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["customer_isEmpty"]}</p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement Type <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={enagagementTypeOptions}
                placeholder="Select"
                isDisabled={false}
                value={enagagementType}
                onChange={(event) => selectOnChange(event, "enagagementType")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>
                {formErrors["enagagementType_isEmpty"]}
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Engagement Status <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={engagementStatusOptions}
                placeholder="Select"
                isDisabled={false}
                value={engagementStatus}
                onChange={(event) => selectOnChange(event, "engagementStatus")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>
                {formErrors["engagementStatus_isEmpty"]}
              </p>
            </div>
          </div>
          {!(enagagementType.label === "INTERNAL") && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Stages <sup>*</sup>
                </label>
                <SelectForm
                  key={1}
                  options={stagesOptions}
                  placeholder="Select"
                  isDisabled={submitId !== 0 ? true : false}
                  value={stageValue}
                  onChange={(event) => selectOnChange(event, "stages")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
                <p style={{ color: "red" }}>{formErrors["stage_isEmpty"]}</p>
              </div>
            </div>
          )}
          <div className="col-lg-4 col-md-4 col-sm-6">
            <div className="form-group">
              <label>
                Stream <sup>*</sup>
              </label>
              <SelectForm
                key={1}
                options={streamsOptions}
                placeholder="Select"
                isDisabled={false}
                value={streamValue}
                onChange={(event) => selectOnChange(event, "stream")}
                isMulti={false}
                noIndicator={false}
                noSeparator={false}
              />
              <p style={{ color: "red" }}>{formErrors["stream_isEmpty"]}</p>
            </div>
          </div>
          {!(enagagementType.label === "INTERNAL") && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>
                  Functional Owner <sup>*</sup>
                </label>
                <SelectForm
                  key={1}
                  options={functionOwnersOptions}
                  placeholder="Select"
                  isDisabled={false}
                  value={functionOwners}
                  onChange={(event) => selectOnChange(event, "functionOwner")}
                  isMulti={false}
                  noIndicator={false}
                  noSeparator={false}
                />
                <p style={{ color: "red" }}>
                  {formErrors["functionOwner_isEmpty"]}
                </p>
              </div>
            </div>
          )}

          {!(!enagagementType || Object.keys(enagagementType).length === 0) && (
            <>
              {!(enagagementType.label === "INTERNAL") && (
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      PO Value <sup>*</sup>
                    </label>
                    <InputForm
                      placeholder={"POValue"}
                      isDisabled={false}
                      textArea={false}
                      value={povalue}
                      onChange={(e) => handleTextEvent(e, "povalue")}
                      className="numRight"
                      type="number"
                      onKeyPress={(event) => {
                        if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["povalue_isEmpty"]}
                    </p>
                  </div>
                </div>
              )}

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    PO Status <sup>*</sup>
                  </label>
                  <SelectForm
                    key={1}
                    options={poStatusOptions}
                    placeholder="Select"
                    isDisabled={false}
                    value={poStatus}
                    onChange={(event) => selectOnChange(event, "poStatus")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["poStatus_isEmpty"]}
                  </p>
                </div>
              </div>

              {(enagagementType.label === "AMC" ||
                enagagementType.label === "T&M") && (
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      PO Months <sup>*</sup>
                    </label>
                    <InputForm
                      placeholder={"PO Months"}
                      isDisabled={false}
                      textArea={false}
                      value={pomonths}
                      onChange={(e) => handleTextEvent(e, "pomonths")}
                      className="numRight"
                      type="number"
                      onKeyPress={(event) => {
                        if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["pomonths_isEmpty"]}
                    </p>
                  </div>
                </div>
              )}
            </>
          )}

          {(enagagementType.label === "AMC" ||
            enagagementType.label === "T&M") && (
            <div className="col-lg-4 col-md-4 col-sm-6">
              <div className="form-group">
                <label>PO Expiry Date</label>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    label="PO Expiry Date"
                    value={poExpiryDate}
                    onChange={(e) => handleTextEvent(e, "poExpiryDate")}
                    inputFormat="dd/MM/yyyy"
                    renderInput={(params) => (
                      <TextField size="small" {...params} />
                    )}
                    minDate
                    PopperProps={{
                      disablePortal: true,
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, 8],
                          },
                        },
                        {
                          name: "preventOverflow",
                          options: {
                            enabled: true,
                            boundariesElement: "viewport",
                          },
                        },
                      ],
                    }}
                  />
                </LocalizationProvider>
                <p style={{ color: "red" }}>
                  {formErrors["poExpiryDate_isEmpty"]}
                </p>
              </div>
            </div>
          )}

          {enagagementType.label === "T&M" && stagesOptions.length > 0 && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    PO Resources / M <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"PO Resources / M"}
                    isDisabled={false}
                    textArea={false}
                    value={poResourcesPerMonth}
                    onChange={(e) => handleTextEvent(e, "poResourcesPerMonth")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["poResourcesPerMonth_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Budget Resources / M <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"POValue"}
                    isDisabled={false}
                    textArea={false}
                    value={budgetResourcesPerMonth}
                    onChange={(e) =>
                      handleTextEvent(e, "budgetResourcesPerMonth")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["budgetResourcesPerMonth_isEmpty"]}
                  </p>
                </div>
              </div>
            </>
          )}

          {enagagementType.label === "AMC" && stagesOptions.length > 0 && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    PO Mandays / M <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"PO Mandays / M"}
                    isDisabled={false}
                    textArea={false}
                    value={poMandaysPerMonth}
                    onChange={(e) => handleTextEvent(e, "poMandaysPerMonth")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["poMandaysPerMonth_isEmpty"]}
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Budget Mandays / M <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"Budget Mandays / M"}
                    isDisabled={false}
                    textArea={false}
                    value={budgetMandaysPerMonth}
                    onChange={(e) =>
                      handleTextEvent(e, "budgetMandaysPerMonth")
                    }
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["budgetMandaysPerMonth_isEmpty"]}
                  </p>
                </div>
              </div>
            </>
          )}

          {(enagagementType.label === "PROJECT" ||
            enagagementType.label === "PRODUCT" ||
            enagagementType.label === "INTERNAL") && (
            <>
              {(enagagementType.label === "PROJECT" ||
                enagagementType.label === "PRODUCT") && (
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      PO Mandays <sup>*</sup>
                    </label>
                    <InputForm
                      placeholder={"PO Mandays"}
                      isDisabled={false}
                      textArea={false}
                      value={poMandays}
                      onChange={(e) => handleTextEvent(e, "poMandays")}
                      className="numRight"
                      type="number"
                      onKeyPress={(event) => {
                        if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["poMandays_isEmpty"]}
                    </p>
                  </div>
                </div>
              )}
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Budget Mandays <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"Budget Mandays"}
                    isDisabled={false}
                    textArea={false}
                    value={budgetMandays}
                    onChange={(e) => handleTextEvent(e, "budgetMandays")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["budgetMandays_isEmpty"]}
                  </p>
                </div>
              </div>
            </>
          )}

          {(enagagementType.label === "AMC" ||
            enagagementType.label === "T&M") && (
            <>
              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Billing <sup>*</sup>
                  </label>
                  <SelectForm
                    key={1}
                    options={billingOptions}
                    placeholder="Select"
                    isDisabled={false}
                    value={billing}
                    onChange={(event) => selectOnChange(event, "billing")}
                    isMulti={false}
                    noIndicator={false}
                    noSeparator={false}
                  />
                  <p style={{ color: "red" }}>
                    {formErrors["billing_isEmpty"]}
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-4 col-sm-6">
                <div className="form-group">
                  <label>
                    Amount <sup>*</sup>
                  </label>
                  <InputForm
                    placeholder={"Amount"}
                    isDisabled={false}
                    textArea={false}
                    value={amount}
                    onChange={(e) => handleTextEvent(e, "amount")}
                    className="numRight"
                    type="number"
                    onKeyPress={(event) => {
                      if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                  />
                  <p style={{ color: "red" }}>{formErrors["amount_isEmpty"]}</p>
                </div>
              </div>

              {(billing.value == 2 || billing.value == 3) && (
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Billing Months <sup>*</sup>
                    </label>
                    <SelectForm
                      key={1}
                      options={billingMonthOption}
                      placeholder="Select"
                      isDisabled={billingMonthDisable}
                      value={billingmonthvalue}
                      onChange={(event) =>
                        selectOnChange(event, "billingmonth")
                      }
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["billingmonth_isEmpty"]}
                    </p>
                  </div>
                </div>
              )}
            </>
          )}

          {(enagagementType.label === "AMC" ||
            enagagementType.label === "T&M") &&
            billing.value != 4 && (
              <>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>
                      Currency <sup>*</sup>{" "}
                    </label>
                    <SelectForm
                      options={POCurrencyOptions}
                      placeholder="Currency"
                      value={POCurrencySelectData}
                      onChange={(event) => selectOnChange(event, "POCurrency")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    <p style={{ color: "red" }}>
                      {formErrors["poCurrency_isEmpty"]}
                    </p>
                  </div>
                </div>

                {POCurrencySelectData && POCurrencySelectData.value == 1 ? (
                  <>
                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          INR Conversion Rate <sup>*</sup>
                        </label>
                        <InputForm
                          placeholder={"INR Conversion Rate"}
                          isDisabled={true}
                          textArea={false}
                          value={InrConvertRate}
                          onChange={(event) =>
                            handleTextEvent(event, "INRConvertRate")
                          }
                          className="numRight"
                          type="number"
                          onKeyPress={(event) => {
                            if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["INRConvertRate_isEmpty"]}
                        </p>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-lg-4 col-md-4 col-sm-6">
                      <div className="form-group">
                        <label>
                          INR Conversion Rate <sup>*</sup>
                        </label>
                        <InputForm
                          placeholder={"INR Conversion Rate"}
                          isDisabled={false}
                          textArea={false}
                          value={InrConvertRate}
                          onChange={(event) =>
                            handleTextEvent(event, "INRConvertRate")
                          }
                          className="numRight"
                          type="number"
                          onKeyPress={(event) => {
                            if (!/^[0-9]*(\.[0-9]{0,2})?$/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                        />
                        <p style={{ color: "red" }}>
                          {formErrors["INRConvertRate_isEmpty"]}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>INR Amount {/*<sup>*</sup> */}</label>
                    <InputForm
                      placeholder={"INR Conversion Rate * Amount"}
                      isDisabled={true}
                      textArea={false}
                      value={InrAmount}
                      onChange={(event) => handleTextEvent(event, "INRAmount")}
                    />
                    {/* <p style={{ color: "red" }}>
                        {formErrors["INRAmount_isEmpty"]}
                       </p> */}
                  </div>
                </div>
              </>
            )}

          {state && (
            <div className="col-lg-12">
              <div className="form-group">
                <label htmlFor="isActive" className="d-inline-block mr-2">
                  Is Active
                </label>
                <input
                  id="isActive"
                  type="checkbox"
                  onChange={(e) => setIsActive(e.target.checked)}
                  name="isActive"
                  checked={isActive}
                />
              </div>
            </div>
          )}

          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <button onClick={() => navigate(-1)} className="btn btn-reset">
                <i className="fa fa-chevron-left"></i>
              </button>
              <button
                onClick={() => submitFunc("submit")}
                className="btn btn-submit"
                disabled={disabled}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EngagementMasterEdit;
